

import { Box, InputLabel, TextField } from "@mui/material";
import styles from './FormInpuEditor.module.scss';
import classNames from 'classnames/bind';
import { getUnit } from "@mui/material/styles/cssUtils";
import { getIn } from "formik";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const cx = classNames.bind(styles);

const FormInpuEditor = (props: {
  name: string;
  text: string;
  form?: any;
  placeholder: string;
  inputkey: string;
  value?: string;
  disable?: boolean;
  onChange?: (e: any) => void;
  width?: string;
  restrictNumber?: boolean; 
  height?:string;
  isViewMode?:boolean;
  errorMessage?:string;
}) => {
  const {
    name,
    text,
    form,
    placeholder,
    inputkey,
    value,
    onChange,
    disable,
    width,
    restrictNumber, 
    height,
    isViewMode,
    errorMessage
  } = props;
    

  const error = errorMessage ? errorMessage : getIn(form?.errors, inputkey);
  const getUnit = (unit:string) =>{

    return unit
  }
  
  const handleInputChange = (inputValue: string) => {
    let updatedValue = inputValue;
    if (onChange) {
      onChange(updatedValue);
    }

    if (form) {
      form.setFieldValue(inputkey, updatedValue);
    }
  };

  return (
    <Box className="w-full">
      {text && <InputLabel className={cx("form-input-title")}>{text}</InputLabel>}

      {
        isViewMode ? <>
          <div className={cx({
            "box-view":true,
          })} style={{
            height: height? height : "50px"
          }}>
            
            <div
                dangerouslySetInnerHTML={{ __html: value! }}
            />
          </div>
        </> : <Box
        className={cx({
          "box-form-input": true,
        })}
        style={{
          width: width,
        }}
      >
        <div className={cx('form-input')} style={{
            height: height ? height : "150px",
        }}>
            <ReactQuill   
                modules={{
                    toolbar: [
                        [{ size: ["small", false, "large", "huge"] }],
                        [{ color: [] }],
                        ["bold", "italic", "underline"],
                        [
                            { list: "ordered" },
                            { list: "bullet" },
                        ],
                    ],
                }}
                formats={[
                    "size",
                    "color",
                    "bold",
                    "italic",
                    "underline",
                    "strike",
                    "list",
                    "bullet",
                ]}
                value={value !== undefined ? value : form?.values[inputkey]}
                onChange={handleInputChange}
            />
        </div>
        {errorMessage && <p className={cx("error-message")}>{errorMessage}</p>}

      </Box>
      }
      
    </Box>
  );
};

export default FormInpuEditor;